/* tslint:disable */
/* eslint-disable */
/**
 * Shihuo API
 * ### Shihuo API  Данные о товарах: карточка товара, цены по площадкам и поиск.  #### Авторизация - **x-api-key** — API-ключ доступа (заголовок `x-api-key`, также принимается алиас `apikey`). - **x-service-api-key** — ключ для доверенных сервисов (заголовок `x-service-api-key`).
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiError } from '../models';
// @ts-ignore
import type { ArticleMatchResponse } from '../models';
// @ts-ignore
import type { PriceResponse } from '../models';
// @ts-ignore
import type { ProductDetailResponse } from '../models';
// @ts-ignore
import type { ProductFullResponse } from '../models';
// @ts-ignore
import type { SearchResponse } from '../models';
/**
 * ShihuoAPIApi - axios parameter creator
 * @export
 */
export const ShihuoAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Возвращает товар с ТОЧНЫМ совпадением артикула (货号) среди верхних результатов поиска (совпадение верифицируется по карточке, не по позиции). 404 — артикула нет на Shihuo; 503 — поиск временно недоступен (повтор имеет смысл).
         * @summary Поиск товара Shihuo по артикулу (货号) — резолв идентификаторов (goodsId/styleId)
         * @param {string} article артикул (货号), напр. DD1391-100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        byArticle: async (article: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'article' is not null or undefined
            assertParamExists('byArticle', 'article', article)
            const localVarPath = `/api/shihuo/by-article/{article}`
                .replace(`{${"article"}}`, encodeURIComponent(String(article)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Без `store` — предложения со всех площадок. С `store=dewu` фильтрует до 得物 (Dewu): в обычном (нефильтрованном) ответе 得物-офферов нет. У каждого оффера есть `platform` (id товара на площадке + публичная ссылка); для 得物 `platform.itemId` = dewu spuId, `platform.url` = fast.dewu.com — мост Shihuo→Dewu без артикула. Площадки: `taobao`/`jd`/`tmall`/`douyin`/`fen95`/`official`/`all`.
         * @summary Цены по товару: предложения продавцов с разных площадок
         * @param {number} goodsId goods_id (SPU товара)
         * @param {number} styleId style_id (расцветка/стиль)
         * @param {number} [skuId] sku_id размера; 0/не задан &#x3D; авто-подбор размера в наличии с макс. продавцов
         * @param {PriceStoreEnum} [store] фильтр по площадке; пусто &#x3D; все площадки. &#x60;platform&#x60; (id + ссылка на площадке) есть у оффера в любом случае. Неизвестное значение → 400
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        price: async (goodsId: number, styleId: number, skuId?: number, store?: PriceStoreEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goodsId' is not null or undefined
            assertParamExists('price', 'goodsId', goodsId)
            // verify required parameter 'styleId' is not null or undefined
            assertParamExists('price', 'styleId', styleId)
            const localVarPath = `/api/shihuo/price/{goodsId}`
                .replace(`{${"goodsId"}}`, encodeURIComponent(String(goodsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (styleId !== undefined) {
                localVarQueryParameter['styleId'] = styleId;
            }

            if (skuId !== undefined) {
                localVarQueryParameter['skuId'] = skuId;
            }

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Карточка товара: описание, справочная цена, размеры
         * @param {number} goodsId goods_id (SPU товара)
         * @param {number} styleId style_id (расцветка/стиль)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        product: async (goodsId: number, styleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goodsId' is not null or undefined
            assertParamExists('product', 'goodsId', goodsId)
            // verify required parameter 'styleId' is not null or undefined
            assertParamExists('product', 'styleId', styleId)
            const localVarPath = `/api/shihuo/product/{goodsId}`
                .replace(`{${"goodsId"}}`, encodeURIComponent(String(goodsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (styleId !== undefined) {
                localVarQueryParameter['styleId'] = styleId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает карточку товара (описание, бренд, галерея, размерная сетка) вместе с текущими ценами продавцов по каждому размеру — за один запрос вместо отдельных вызовов /product и /price. Каждое предложение несёт `delivery` (срок доставки) и `platform` (id/ссылка на площадке-источнике); `store` фильтрует предложения по площадке (как в /price).  Тарификация: пакетная — списывает 5 запросов с квоты (для сравнения, /product и /price стоят по 1 запросу).  Ответ полный или ошибка (complete-or-error): 200 отдаётся ТОЛЬКО когда получены и карточка, и разбивка по продавцам (`suppliers`) по всем размерам. Сбой разбивки по размеру ретраится; если после ретраев её всё же не удалось получить (или не уложились в отведённое время) — вся ручка отдаёт 503 (частичного ответа нет, повтор имеет смысл).  Коды ответа: 404 — товар не найден; 503 — карточка или разбивка по размерам временно недоступна. Квота списывается при 200 и при 404 (источник ответил); при 503 не списывается.
         * @summary Карточка товара + цены продавцов по всем размерам за один вызов
         * @param {number} goodsId goods_id (SPU товара)
         * @param {number} styleId style_id (расцветка/стиль)
         * @param {boolean} [inStockOnly] запрашивать цены только по размерам в наличии (есть предложения продавцов)
         * @param {number} [maxSizes] ограничить число размеров для запроса цен (0 &#x3D; все размеры)
         * @param {ProductFullStoreEnum} [store] фильтр по площадке; пусто &#x3D; все площадки (как в /price). Неизвестное → 400
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productFull: async (goodsId: number, styleId: number, inStockOnly?: boolean, maxSizes?: number, store?: ProductFullStoreEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goodsId' is not null or undefined
            assertParamExists('productFull', 'goodsId', goodsId)
            // verify required parameter 'styleId' is not null or undefined
            assertParamExists('productFull', 'styleId', styleId)
            const localVarPath = `/api/shihuo/product-full/{goodsId}`
                .replace(`{${"goodsId"}}`, encodeURIComponent(String(goodsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (styleId !== undefined) {
                localVarQueryParameter['styleId'] = styleId;
            }

            if (inStockOnly !== undefined) {
                localVarQueryParameter['inStockOnly'] = inStockOnly;
            }

            if (maxSizes !== undefined) {
                localVarQueryParameter['maxSizes'] = maxSizes;
            }

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Поиск товаров по ключевому слову
         * @param {string} query поисковый запрос
         * @param {number} [page] номер страницы (начиная с 1)
         * @param {number} [pageSize] количество результатов на странице (максимум 50)
         * @param {number} [priceMin] минимальная цена
         * @param {number} [priceMax] максимальная цена
         * @param {SearchSortEnum} [sort] сортировка выдачи: &#x60;newest&#x60; (сначала новые), &#x60;sales&#x60; (по продажам), &#x60;price_asc&#x60;/&#x60;price_desc&#x60; (по цене), &#x60;relevance&#x60; (по релевантности, дефолт). Пусто &#x3D; relevance. Неизвестное значение → 400
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (query: string, page?: number, pageSize?: number, priceMin?: number, priceMax?: number, sort?: SearchSortEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('search', 'query', query)
            const localVarPath = `/api/shihuo/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['priceMin'] = priceMin;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['priceMax'] = priceMax;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShihuoAPIApi - functional programming interface
 * @export
 */
export const ShihuoAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShihuoAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Возвращает товар с ТОЧНЫМ совпадением артикула (货号) среди верхних результатов поиска (совпадение верифицируется по карточке, не по позиции). 404 — артикула нет на Shihuo; 503 — поиск временно недоступен (повтор имеет смысл).
         * @summary Поиск товара Shihuo по артикулу (货号) — резолв идентификаторов (goodsId/styleId)
         * @param {string} article артикул (货号), напр. DD1391-100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async byArticle(article: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleMatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.byArticle(article, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShihuoAPIApi.byArticle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Без `store` — предложения со всех площадок. С `store=dewu` фильтрует до 得物 (Dewu): в обычном (нефильтрованном) ответе 得物-офферов нет. У каждого оффера есть `platform` (id товара на площадке + публичная ссылка); для 得物 `platform.itemId` = dewu spuId, `platform.url` = fast.dewu.com — мост Shihuo→Dewu без артикула. Площадки: `taobao`/`jd`/`tmall`/`douyin`/`fen95`/`official`/`all`.
         * @summary Цены по товару: предложения продавцов с разных площадок
         * @param {number} goodsId goods_id (SPU товара)
         * @param {number} styleId style_id (расцветка/стиль)
         * @param {number} [skuId] sku_id размера; 0/не задан &#x3D; авто-подбор размера в наличии с макс. продавцов
         * @param {PriceStoreEnum} [store] фильтр по площадке; пусто &#x3D; все площадки. &#x60;platform&#x60; (id + ссылка на площадке) есть у оффера в любом случае. Неизвестное значение → 400
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async price(goodsId: number, styleId: number, skuId?: number, store?: PriceStoreEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.price(goodsId, styleId, skuId, store, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShihuoAPIApi.price']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Карточка товара: описание, справочная цена, размеры
         * @param {number} goodsId goods_id (SPU товара)
         * @param {number} styleId style_id (расцветка/стиль)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async product(goodsId: number, styleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.product(goodsId, styleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShihuoAPIApi.product']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает карточку товара (описание, бренд, галерея, размерная сетка) вместе с текущими ценами продавцов по каждому размеру — за один запрос вместо отдельных вызовов /product и /price. Каждое предложение несёт `delivery` (срок доставки) и `platform` (id/ссылка на площадке-источнике); `store` фильтрует предложения по площадке (как в /price).  Тарификация: пакетная — списывает 5 запросов с квоты (для сравнения, /product и /price стоят по 1 запросу).  Ответ полный или ошибка (complete-or-error): 200 отдаётся ТОЛЬКО когда получены и карточка, и разбивка по продавцам (`suppliers`) по всем размерам. Сбой разбивки по размеру ретраится; если после ретраев её всё же не удалось получить (или не уложились в отведённое время) — вся ручка отдаёт 503 (частичного ответа нет, повтор имеет смысл).  Коды ответа: 404 — товар не найден; 503 — карточка или разбивка по размерам временно недоступна. Квота списывается при 200 и при 404 (источник ответил); при 503 не списывается.
         * @summary Карточка товара + цены продавцов по всем размерам за один вызов
         * @param {number} goodsId goods_id (SPU товара)
         * @param {number} styleId style_id (расцветка/стиль)
         * @param {boolean} [inStockOnly] запрашивать цены только по размерам в наличии (есть предложения продавцов)
         * @param {number} [maxSizes] ограничить число размеров для запроса цен (0 &#x3D; все размеры)
         * @param {ProductFullStoreEnum} [store] фильтр по площадке; пусто &#x3D; все площадки (как в /price). Неизвестное → 400
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productFull(goodsId: number, styleId: number, inStockOnly?: boolean, maxSizes?: number, store?: ProductFullStoreEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductFullResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productFull(goodsId, styleId, inStockOnly, maxSizes, store, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShihuoAPIApi.productFull']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Поиск товаров по ключевому слову
         * @param {string} query поисковый запрос
         * @param {number} [page] номер страницы (начиная с 1)
         * @param {number} [pageSize] количество результатов на странице (максимум 50)
         * @param {number} [priceMin] минимальная цена
         * @param {number} [priceMax] максимальная цена
         * @param {SearchSortEnum} [sort] сортировка выдачи: &#x60;newest&#x60; (сначала новые), &#x60;sales&#x60; (по продажам), &#x60;price_asc&#x60;/&#x60;price_desc&#x60; (по цене), &#x60;relevance&#x60; (по релевантности, дефолт). Пусто &#x3D; relevance. Неизвестное значение → 400
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(query: string, page?: number, pageSize?: number, priceMin?: number, priceMax?: number, sort?: SearchSortEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(query, page, pageSize, priceMin, priceMax, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShihuoAPIApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ShihuoAPIApi - factory interface
 * @export
 */
export const ShihuoAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShihuoAPIApiFp(configuration)
    return {
        /**
         * Возвращает товар с ТОЧНЫМ совпадением артикула (货号) среди верхних результатов поиска (совпадение верифицируется по карточке, не по позиции). 404 — артикула нет на Shihuo; 503 — поиск временно недоступен (повтор имеет смысл).
         * @summary Поиск товара Shihuo по артикулу (货号) — резолв идентификаторов (goodsId/styleId)
         * @param {string} article артикул (货号), напр. DD1391-100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        byArticle(article: string, options?: RawAxiosRequestConfig): AxiosPromise<ArticleMatchResponse> {
            return localVarFp.byArticle(article, options).then((request) => request(axios, basePath));
        },
        /**
         * Без `store` — предложения со всех площадок. С `store=dewu` фильтрует до 得物 (Dewu): в обычном (нефильтрованном) ответе 得物-офферов нет. У каждого оффера есть `platform` (id товара на площадке + публичная ссылка); для 得物 `platform.itemId` = dewu spuId, `platform.url` = fast.dewu.com — мост Shihuo→Dewu без артикула. Площадки: `taobao`/`jd`/`tmall`/`douyin`/`fen95`/`official`/`all`.
         * @summary Цены по товару: предложения продавцов с разных площадок
         * @param {number} goodsId goods_id (SPU товара)
         * @param {number} styleId style_id (расцветка/стиль)
         * @param {number} [skuId] sku_id размера; 0/не задан &#x3D; авто-подбор размера в наличии с макс. продавцов
         * @param {PriceStoreEnum} [store] фильтр по площадке; пусто &#x3D; все площадки. &#x60;platform&#x60; (id + ссылка на площадке) есть у оффера в любом случае. Неизвестное значение → 400
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        price(goodsId: number, styleId: number, skuId?: number, store?: PriceStoreEnum, options?: RawAxiosRequestConfig): AxiosPromise<PriceResponse> {
            return localVarFp.price(goodsId, styleId, skuId, store, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Карточка товара: описание, справочная цена, размеры
         * @param {number} goodsId goods_id (SPU товара)
         * @param {number} styleId style_id (расцветка/стиль)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        product(goodsId: number, styleId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductDetailResponse> {
            return localVarFp.product(goodsId, styleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает карточку товара (описание, бренд, галерея, размерная сетка) вместе с текущими ценами продавцов по каждому размеру — за один запрос вместо отдельных вызовов /product и /price. Каждое предложение несёт `delivery` (срок доставки) и `platform` (id/ссылка на площадке-источнике); `store` фильтрует предложения по площадке (как в /price).  Тарификация: пакетная — списывает 5 запросов с квоты (для сравнения, /product и /price стоят по 1 запросу).  Ответ полный или ошибка (complete-or-error): 200 отдаётся ТОЛЬКО когда получены и карточка, и разбивка по продавцам (`suppliers`) по всем размерам. Сбой разбивки по размеру ретраится; если после ретраев её всё же не удалось получить (или не уложились в отведённое время) — вся ручка отдаёт 503 (частичного ответа нет, повтор имеет смысл).  Коды ответа: 404 — товар не найден; 503 — карточка или разбивка по размерам временно недоступна. Квота списывается при 200 и при 404 (источник ответил); при 503 не списывается.
         * @summary Карточка товара + цены продавцов по всем размерам за один вызов
         * @param {number} goodsId goods_id (SPU товара)
         * @param {number} styleId style_id (расцветка/стиль)
         * @param {boolean} [inStockOnly] запрашивать цены только по размерам в наличии (есть предложения продавцов)
         * @param {number} [maxSizes] ограничить число размеров для запроса цен (0 &#x3D; все размеры)
         * @param {ProductFullStoreEnum} [store] фильтр по площадке; пусто &#x3D; все площадки (как в /price). Неизвестное → 400
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productFull(goodsId: number, styleId: number, inStockOnly?: boolean, maxSizes?: number, store?: ProductFullStoreEnum, options?: RawAxiosRequestConfig): AxiosPromise<ProductFullResponse> {
            return localVarFp.productFull(goodsId, styleId, inStockOnly, maxSizes, store, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Поиск товаров по ключевому слову
         * @param {string} query поисковый запрос
         * @param {number} [page] номер страницы (начиная с 1)
         * @param {number} [pageSize] количество результатов на странице (максимум 50)
         * @param {number} [priceMin] минимальная цена
         * @param {number} [priceMax] максимальная цена
         * @param {SearchSortEnum} [sort] сортировка выдачи: &#x60;newest&#x60; (сначала новые), &#x60;sales&#x60; (по продажам), &#x60;price_asc&#x60;/&#x60;price_desc&#x60; (по цене), &#x60;relevance&#x60; (по релевантности, дефолт). Пусто &#x3D; relevance. Неизвестное значение → 400
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(query: string, page?: number, pageSize?: number, priceMin?: number, priceMax?: number, sort?: SearchSortEnum, options?: RawAxiosRequestConfig): AxiosPromise<SearchResponse> {
            return localVarFp.search(query, page, pageSize, priceMin, priceMax, sort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShihuoAPIApi - object-oriented interface
 * @export
 * @class ShihuoAPIApi
 * @extends {BaseAPI}
 */
export class ShihuoAPIApi extends BaseAPI {
    /**
     * Возвращает товар с ТОЧНЫМ совпадением артикула (货号) среди верхних результатов поиска (совпадение верифицируется по карточке, не по позиции). 404 — артикула нет на Shihuo; 503 — поиск временно недоступен (повтор имеет смысл).
     * @summary Поиск товара Shihuo по артикулу (货号) — резолв идентификаторов (goodsId/styleId)
     * @param {string} article артикул (货号), напр. DD1391-100
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShihuoAPIApi
     */
    public byArticle(article: string, options?: RawAxiosRequestConfig) {
        return ShihuoAPIApiFp(this.configuration).byArticle(article, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Без `store` — предложения со всех площадок. С `store=dewu` фильтрует до 得物 (Dewu): в обычном (нефильтрованном) ответе 得物-офферов нет. У каждого оффера есть `platform` (id товара на площадке + публичная ссылка); для 得物 `platform.itemId` = dewu spuId, `platform.url` = fast.dewu.com — мост Shihuo→Dewu без артикула. Площадки: `taobao`/`jd`/`tmall`/`douyin`/`fen95`/`official`/`all`.
     * @summary Цены по товару: предложения продавцов с разных площадок
     * @param {number} goodsId goods_id (SPU товара)
     * @param {number} styleId style_id (расцветка/стиль)
     * @param {number} [skuId] sku_id размера; 0/не задан &#x3D; авто-подбор размера в наличии с макс. продавцов
     * @param {PriceStoreEnum} [store] фильтр по площадке; пусто &#x3D; все площадки. &#x60;platform&#x60; (id + ссылка на площадке) есть у оффера в любом случае. Неизвестное значение → 400
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShihuoAPIApi
     */
    public price(goodsId: number, styleId: number, skuId?: number, store?: PriceStoreEnum, options?: RawAxiosRequestConfig) {
        return ShihuoAPIApiFp(this.configuration).price(goodsId, styleId, skuId, store, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Карточка товара: описание, справочная цена, размеры
     * @param {number} goodsId goods_id (SPU товара)
     * @param {number} styleId style_id (расцветка/стиль)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShihuoAPIApi
     */
    public product(goodsId: number, styleId: number, options?: RawAxiosRequestConfig) {
        return ShihuoAPIApiFp(this.configuration).product(goodsId, styleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает карточку товара (описание, бренд, галерея, размерная сетка) вместе с текущими ценами продавцов по каждому размеру — за один запрос вместо отдельных вызовов /product и /price. Каждое предложение несёт `delivery` (срок доставки) и `platform` (id/ссылка на площадке-источнике); `store` фильтрует предложения по площадке (как в /price).  Тарификация: пакетная — списывает 5 запросов с квоты (для сравнения, /product и /price стоят по 1 запросу).  Ответ полный или ошибка (complete-or-error): 200 отдаётся ТОЛЬКО когда получены и карточка, и разбивка по продавцам (`suppliers`) по всем размерам. Сбой разбивки по размеру ретраится; если после ретраев её всё же не удалось получить (или не уложились в отведённое время) — вся ручка отдаёт 503 (частичного ответа нет, повтор имеет смысл).  Коды ответа: 404 — товар не найден; 503 — карточка или разбивка по размерам временно недоступна. Квота списывается при 200 и при 404 (источник ответил); при 503 не списывается.
     * @summary Карточка товара + цены продавцов по всем размерам за один вызов
     * @param {number} goodsId goods_id (SPU товара)
     * @param {number} styleId style_id (расцветка/стиль)
     * @param {boolean} [inStockOnly] запрашивать цены только по размерам в наличии (есть предложения продавцов)
     * @param {number} [maxSizes] ограничить число размеров для запроса цен (0 &#x3D; все размеры)
     * @param {ProductFullStoreEnum} [store] фильтр по площадке; пусто &#x3D; все площадки (как в /price). Неизвестное → 400
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShihuoAPIApi
     */
    public productFull(goodsId: number, styleId: number, inStockOnly?: boolean, maxSizes?: number, store?: ProductFullStoreEnum, options?: RawAxiosRequestConfig) {
        return ShihuoAPIApiFp(this.configuration).productFull(goodsId, styleId, inStockOnly, maxSizes, store, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Поиск товаров по ключевому слову
     * @param {string} query поисковый запрос
     * @param {number} [page] номер страницы (начиная с 1)
     * @param {number} [pageSize] количество результатов на странице (максимум 50)
     * @param {number} [priceMin] минимальная цена
     * @param {number} [priceMax] максимальная цена
     * @param {SearchSortEnum} [sort] сортировка выдачи: &#x60;newest&#x60; (сначала новые), &#x60;sales&#x60; (по продажам), &#x60;price_asc&#x60;/&#x60;price_desc&#x60; (по цене), &#x60;relevance&#x60; (по релевантности, дефолт). Пусто &#x3D; relevance. Неизвестное значение → 400
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShihuoAPIApi
     */
    public search(query: string, page?: number, pageSize?: number, priceMin?: number, priceMax?: number, sort?: SearchSortEnum, options?: RawAxiosRequestConfig) {
        return ShihuoAPIApiFp(this.configuration).search(query, page, pageSize, priceMin, priceMax, sort, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const PriceStoreEnum = {
    Dewu: 'dewu',
    Taobao: 'taobao',
    Jd: 'jd',
    Tmall: 'tmall',
    Douyin: 'douyin',
    Fen95: 'fen95',
    Official: 'official',
    All: 'all'
} as const;
export type PriceStoreEnum = typeof PriceStoreEnum[keyof typeof PriceStoreEnum];
/**
 * @export
 */
export const ProductFullStoreEnum = {
    Dewu: 'dewu',
    Taobao: 'taobao',
    Jd: 'jd',
    Tmall: 'tmall',
    Douyin: 'douyin',
    Fen95: 'fen95',
    Official: 'official',
    All: 'all'
} as const;
export type ProductFullStoreEnum = typeof ProductFullStoreEnum[keyof typeof ProductFullStoreEnum];
/**
 * @export
 */
export const SearchSortEnum = {
    Relevance: 'relevance',
    Newest: 'newest',
    Sales: 'sales',
    PriceAsc: 'price_asc',
    PriceDesc: 'price_desc'
} as const;
export type SearchSortEnum = typeof SearchSortEnum[keyof typeof SearchSortEnum];
